import type { HTMLAttributes } from "react";

import { cn } from "@/lib/utils";

/** A placeholder shaped like the content that is loading. */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden="true"
      className={cn("animate-shimmer rounded-md bg-muted", className)}
      {...props}
    />
  );
}
